module.exports = __webpack_public_path__ + "img/recruit_catch_sp.f2013aca.png";